import * as React from 'react';
import { SaveAltSharp } from '@material-ui/icons';
import ToolTip from '../../common/StyledToolTip';
import { withStyles } from '@material-ui/core';
import { csvFormulaInjectionSanitizer } from '../../../utilities/csvUtils';

const styles = (theme: any) => ({
  headerIconStyles: {
    padding: 10,
    borderLeft: `1px solid ${theme.AppBGColor}`,
    cursor: 'pointer',
    color: theme.iconColor
  }
});

interface ExportCsvButtonProps {
  classes: any;
  gridApi: any;
  fileName?: string;
  title?: string;
}

const ExportCsvButton = ({ classes, gridApi, fileName, title }: ExportCsvButtonProps) => {
  const exportCSV = () => {
    if (!gridApi) {
      return;
    }
    const gridName = gridApi.gridName;
    const columns = gridApi.getColumns();
    const columnKeys = columns
      .filter((column: any) => column.colDef.headerName && column.visible)
      .map((column: any) => column.getColId());

    const params = {
      fileName: fileName || gridName,
      columnKeys,
      processCellCallback: (cell: any) => csvFormulaInjectionSanitizer(cell.value)
    };
    gridApi.exportDataAsCsv(params);
  };
  return (
    <div onClick={exportCSV} className={classes.headerIconStyles}>
      <ToolTip title={title || 'Export Data'}>
        <SaveAltSharp />
      </ToolTip>
    </div>
  );
};

export default withStyles(styles)(ExportCsvButton);
